<template>
  <v-container fluid class="pa-3">
    <div class="text-center">
      <v-chip v-for="p in peers" :key="p.id" close @click:close="leave(p)">
        {{p.name}}
      </v-chip>
    </div>
    <RTCConnection
      v-for="p in peers"
      type="teacher"
      :userId="p.id"
      :localVideoStream="localVideoStream"
      :localAudioStream="localAudioStream"
      @onStateChanged="onStateChanged"
      :key="p.id"
    />
  </v-container>
</template>
<script>
import { db } from "./utils-firebase";
import { media } from "./utils-stream";
import { mapState } from "vuex";
import RTCConnection from "./RTCConnection.vue";
export default {
  components: { RTCConnection },
  data() {
    return {
      localVideoStream: null,
      localAudioStream: null,
      peers: [],
    };
  },
  computed: mapState(["roomId", "userId"]),

  mounted() {
    var pVideo = media.getScreenStream();
    var pAudio = media.getAudioStream();
    Promise.all([pVideo, pAudio]).then((values) => {
      this.localVideoStream = values[0];
      this.localAudioStream = values[1];
      db.watchRoom(this.roomId, this.roomUpdated);
    });
  },
  methods: {
    leave(user) {
      db.delMember(this.roomId, user.id);
    },
    roomUpdated(snapShot) {
      snapShot.forEach((doc) => {
        db.watchMember(this.roomId, doc.id, this.memberUpdated);
      });
    },
    memberUpdated(user) {
      if (user.exists) {
        var found = this.peers.find((p) => p.id == user.id);
        if (!found) {
          // a student joined
          var student = user.data();
          this.peers.push({ id: user.id, name: student.name });
        }
      } else {
        // a sudent exited (deleted from firebase)
        this.peers = this.peers.filter((p) => p.id != user.id);
      }
    },
    onStateChanged(state, userid) {
      if (state == "disconnected") {
        console.log("disconnected, a student is deleted by teacher");
        db.delMember(this.roomId, userid);
      }
    },
  },
};
</script>
